import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';
import Table from 'react-bootstrap/Table';
//import { Link } from "react-router-dom";

import React, { useEffect, useState } from 'react';
import axios from 'axios';


const StockShowTea = () => {

    const [stockData, setStockData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://react-apis.dotlocalhost.com/teastockdisplay.php');
                setStockData(response.data);
            } catch (error) {
                console.error("There was an error fetching the stock data!", error);
            }
        };
        fetchData();

        // sidebar background color set
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("teast");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("teastreg");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []);

    return (

        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Tea Stock Register</h3>
                        </div>
                    </div>

                    <div>
                        <Table striped bordered hover style={{ fontSize: '12px' }}>
                            <thead>
                                <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                    <th style={{ display: 'none' }}>Purchase ID</th>
                                    {/* <th>Product ID</th> */}
                                    <th>Grade</th>
                                    <th>Due Date</th>
                                    <th>Purchage Id</th>
                                    <th>Purchased</th>
                                    <th>Sold</th>
                                    <th>Balance Stock</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stockData.map((item) => (
                                    <tr key={item.purchage_Id}>
                                        <td style={{ display: 'none' }}>{item.purchage_Id}</td>
                                        {/* <td>{item.productid}</td> */}
                                        <td>{item.grade}</td> {/* Product name */}
{/* Using toLocaleDateString(): */}                                        
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{new Date(item.duedate).toLocaleDateString()}</td>
{/* Using toISOString():                                        
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{new Date(item.duedate).toISOString().split('T')[0]}</td>
*/}
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{item.purchage_Id}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{item.totalQuantity} &nbsp;&nbsp; Bags</td>
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{item.totalSalesQuantity ? item.totalSalesQuantity : 0} &nbsp;&nbsp; {item.packing}</td>
                                        <td style={{ textAlign: 'right', paddingRight: '5%' }}>{item.remainingStock} &nbsp;&nbsp; Bags</td>
                                    </tr>
                                ))}
                            </tbody>

                        </Table>
                    </div>

                </div>

            </div>

        </div>

    )
}

export default StockShowTea;